export default __webpack_public_path__ + "media/images/mastodon-not-found-b6e90b5fd9eeeb31e9705cf1abbf74eb.png";